import React from 'react';
import Dashboard from './generic-dashboard';

const LowCreditDashboard = ({ firstName, props, children = null }) => (
  <Dashboard
    message={`Thanks for completing our questionnaire, ${firstName}. We’ll email you with next steps from 'hello@ownup.com' in a few minutes.`}
    articles={[
      {
        href: 'your-credit-score-and-your-financial-well-being',
        title: 'Your Credit Score and Your Financial Well Being'
      },
      {
        href: 'mortgage-approval-roadmap',
        title: 'Your Mortgage Approval Roadmap'
      }
    ]}
    props={props}
  >
    {children}
  </Dashboard>
);

export default LowCreditDashboard;



// WEBPACK FOOTER //
// ./src/products/shared/low-credit-dashboard.js